import { styled } from '@mui/material';

const PopoverWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.red.main,
}));

export { PopoverWrapper };
